import { Card, CardBody, Loader, Stacked } from '@statsbomb/kitbag-components';
import { CardHeightWrapper } from '../card/CardHeightWrapper';

export const NoTextLoader = () => (
  <Card>
    <CardHeightWrapper>
      <CardBody>
        <Stacked direction="column" justifyContent="center" alignItems="center">
          <Loader />
        </Stacked>
      </CardBody>
    </CardHeightWrapper>
  </Card>
);
